module.exports = __webpack_public_path__ + "static/media/heroImage@2x.89306efd.png";